const chooseDistrict = district => ({ type: 'CHOOSE_DISTRICT', district });

export default chooseDistrict;



// WEBPACK FOOTER //
// ./src/Action/Session.js